import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import ScrollReveal from "scrollreveal";
import Sticky from "sticky-js";

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if ($('.js-card-slider-sp').length === 0) {
        return false
      }

      var win = $(window).innerWidth();
      if (win <= 768) {
        $('.js-card-slider-sp').addClass('owl-carousel');
        //->カード_カルーセル
        owls.imagesLoaded(function () {
          $('.js-card-slider-sp').owlCarousel({
            margin: 21,
            dots: true,
            loop: true,
            nav: false,
            autoplayHoverPause: true,
            autoplay: true,
            autoplaySpeed: 500,
            autoWidth: false,
            autoHeight: false,
            center: true,
            stagePadding: 60,
            responsive: {
              // breakpoint from 0 up
              0: {
                items: 1,
              },
              // breakpoint from 750 up
              750: {
                items: 3,
              }
            }
          });
        });
      }
    }



    function reveal() {
      //- スクロールリーバル
      window.sr = ScrollReveal({duration: 600, mobile: false});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }


      sr.reveal(".c-front-service__block", {
        viewFactor: 0.2,
        scale: 1,
        duration: 400,
        delay: 0,
        origin: 'bottom',
        distance: '30px',
        easing: 'cubic-bezier(.8,0,.5,1)'
      }, 100);
      sr.reveal(".c-front-performance__wrap", {
        viewFactor: 0.2,
        scale: 1,
        duration: 400,
        delay: 0,
        origin: 'bottom',
        distance: '30px',
        easing: 'cubic-bezier(.8,0,.5,1)'
      }, 100);
      sr.reveal(".c-front-topics__container", {
        viewFactor: 0.2,
        scale: 1,
        duration: 400,
        delay: 0,
        origin: 'bottom',
        distance: '30px',
        easing: 'cubic-bezier(.8,0,.5,1)'
      }, 100);

      var blocks01 = $("");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1, duration: 700, delay: 700}, 200);
        sr.reveal(item.children[1], {delay: 800, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[2], {delay: 900, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[3], {delay: 1000, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[4], {delay: 1100, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[5], {delay: 1200, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[6], {delay: 1300, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[7], {delay: 1400, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[8], {delay: 1500, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[9], {delay: 1600, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[10], {delay: 1700, scale: 1, origin: 'bottom', distance: '20px'}, 300);
      });
    }



    // --------------- アニメーショントリガー（メインビジュアル,ページヘッダー）
    function animationTrigger(el) {
      $(el).addClass('is-animating');
    }



    // --------------- メインビジュアルのスライダー処理
    let $image = $('.c-main-visual__image-wrap');
    let imageIndex = -1;
    function changeImage() {
      var $slider = $('.c-main-visual__slider');
      if ($slider.length === 0) {
        return false
      }

      imageIndex++;

      var currentNum = imageIndex % $image.length;
      var nextNum = (imageIndex + 1) % $image.length;
      var current = $image.eq(currentNum);
      var next = $image.eq(nextNum);

      $image.removeClass('is-inactive');
      current.removeClass('is-active-default is-active');
      current.addClass('is-inactive');
      next.addClass('is-active');

    }

    function showNextImage() {
      setInterval(changeImage, 5000);
    }



    $(function () {
      owlCarousel();
      menuSlide();
      reveal();
      showNextImage();
      // setInterval(changeImage(), 1000);
      $(window).on('load', function () {
        animationTrigger('.c-main-visual__slider');
        animationTrigger('.c-main-visual__inner');
      });
      animationTrigger('.l-page-header__inner');
      // var sticky = new Sticky('.c-performance-top .c-category-lists');
      var win = $(window).innerWidth();
      if (win <= 750) {
        $('.c-category-lists').attr('data-margin-top', '60');
      }
    });
  }
}

window.GApp = new App();
